import axios from 'axios';
import React from 'react'; 
import { NavLink, Link, Redirect } from 'react-router-dom'; 

class Dashboard extends React.Component {
    constructor(props){
        super(props); 

        this.state = {
            forms: [],
            formsApiChecked: false,
            redirect: ''
        }
    }

    componentDidMount(){
        if (this.props.userdata.isLoggedIn){
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }
            axios.get(this.props.apiurl + '/api/forms', {headers: headers}).then(res => {
                this.setState({
                    forms: res.data.forms
                })
            }).catch(err => {
                console.log(err); 
            })
        }
    }

    componentDidUpdate(){
        if (this.props.userdata.isLoggedIn && this.state.formsApiChecked === false){
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }
            axios.get(this.props.apiurl + '/api/forms', {headers: headers}).then(res => {
                this.setState({
                    forms: res.data.forms,
                    formsApiChecked: true
                })
            }).catch(err => {
                console.log(err); 
            })
        }
    }

    handleDeleteForm = (formCode, userId) => {
        console.log(userId); 
        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }
 
        axios.post(this.props.apiurl + '/api/form/delete', { 
            formCode: formCode,
            userId: userId
        },{ 
            headers: headers 
        }).then(res => {
            this.setState({
                forms: res.data.forms
            })
        }).catch(err => {
            console.log(err);
        }); 

    }

    handleEditForm = (formCode, userId) => {
        if (this.props.userdata.isLoggedIn) {
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }

            axios.post(this.props.apiurl + '/api/forms/getform', {
                formCode: formCode,
            }, {
                headers: headers
            }).then(res => {
                this.props.redirectForEdit(res.data.form[0]);
                this.setState({
                    redirect: <Redirect to="/formBuilder"></Redirect>
                });
            }).catch(err => {
                console.log(err);
            });
        }
    }

    handleCopyToClipboard = (text) => {
        let link = this.props.url + '/form/' + text; 
        navigator.clipboard.writeText(link)
    }



    render(){
        let redirect = this.state.redirect; 

        let forms = []; 
        document.body.style.backgroundColor = "#ffffff"; 

        this.state.forms.map((form, index) => {
            const x = JSON.parse(form.json);  
            const startDate = new Date(Date.parse(x.startDate)).setHours(0,0,0,0); 
            const endDate = new Date(Date.parse(x.endDate)).setHours(0,0,0,0); 
            const now = new Date(Date.now()).setHours(0,0,0,0); 
            let disabled = false; 
            
            if (now > startDate && now < endDate){
                if (this.props.userdata.roles != 'admin'){
                    disabled = true; 
                }
            }

            forms.push(
                <tr key={index}>
                    <th scope="row"><button className="btn btn-sm btn-outline-primary" onClick={ () => this.handleCopyToClipboard(form.formCode)}>{ form.formCode }</button> </th>
                    <td>{ form.name }</td>
                    <td>
                        <button className="btn btn-sm btn-outline-secondary mx-1" disabled={disabled}  onClick={ () => this.handleEditForm(form.formCode, this.props.userdata.userId)}>Edit</button>
                        <Link rel="noopener noreferrer"  className="btn btn-sm btn-outline-secondary mx-1" to={"/form/" + form.formCode}>Preview</Link>
                        <button className="btn btn-sm btn-outline-danger mx-1" onClick={ () => this.handleDeleteForm(form.formCode, this.props.userdata.userId)}>Delete</button>
                        
                    </td>
                </tr>
            )
        }); 


        return(
            <div className="container">
                <div className="row mb-2">
                    <div className="col">
                        <h4>Forms</h4>
                        <NavLink className="btn btn-sm btn-outline-secondary mb-2" to="/formbuilder">Add New Form</NavLink>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Form Code <small>Copy to Clipboard</small></th>
                                    <th scope="col">Name</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                { forms } 
                                { redirect }
                              
                               
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        ); 
    }
}

export default Dashboard; 